import { isSocialPlatform } from '@/types/api/platforms';

export const TOP_PLAYER_CATEGORY = {
  podcastPlayerApps: 'Podcast player apps',
  webPodcastPlayers: 'Web podcast players',
  socialPlatforms: 'Social platforms',
  other: 'Other',
} as const;

export const topPlayersLegend = (
  legend: Array<{ category: string; description: string }>,
  data: Array<{ values: Array<{ label: string }> }>
): Array<{ category: string; description: string }> => {
  const categoriesInData = new Set(
    data.flatMap((item) => item.values.map(({ label }) => label))
  );

  return legend.filter((item) => categoriesInData.has(item.category));
};

export const getDisplayLabel = (label: string | null | undefined): string =>
  label?.trim() ? label : 'Unknown';

export const isSocialTopPlayerLabel = (label: string | null | undefined): boolean =>
  isSocialPlatform(getDisplayLabel(label));
